// ═══════════════════════════════════════════════════════
// Shared formatting for the property audit trail.
// Used by the Properties Audit Log modal AND the standalone
// /dashboard/audit page so badges & dates stay consistent.
// ═══════════════════════════════════════════════════════

export interface AuditRow {
  id: number;
  property_id: number | null;
  action: string;
  by_user_id: number | null;
  by_name: string | null;
  details: string | null;
  created_at: string;
  property_title: string | null;
}

export function actionBadge(action: string): { cls: string; icon: string; label: string } {
  const map: Record<string, { cls: string; icon: string; label: string }> = {
    CREATE: { cls: 'bg-sky-500/10 text-sky-500 border-sky-500/25', icon: 'ri-add-circle-line', label: 'Create' },
    UPLOAD: { cls: 'bg-sky-500/10 text-sky-500 border-sky-500/25', icon: 'ri-upload-2-line', label: 'Upload' },
    APPROVE: { cls: 'bg-emerald-500/10 text-emerald-500 border-emerald-500/25', icon: 'ri-check-double-line', label: 'Approve' },
    UNPUBLISH: { cls: 'bg-orange-500/10 text-orange-600 border-orange-500/25', icon: 'ri-eye-off-line', label: 'Unpublish' },
    REJECT: { cls: 'bg-rose-500/10 text-rose-500 border-rose-500/25', icon: 'ri-close-circle-line', label: 'Reject' },
    DELETE: { cls: 'bg-rose-500/10 text-rose-500 border-rose-500/25', icon: 'ri-delete-bin-line', label: 'Delete' },
    UPDATE: { cls: 'bg-amber-500/10 text-amber-600 border-amber-500/25', icon: 'ri-edit-line', label: 'Update' },
    TOGGLE: { cls: 'bg-amber-500/10 text-amber-600 border-amber-500/25', icon: 'ri-toggle-line', label: 'Toggle' },
    PENDING: { cls: 'bg-secondary-100 text-secondary-700 border-secondary-200', icon: 'ri-time-line', label: 'Pending' },
  };
  return map[(action || '').toUpperCase()] || { cls: 'bg-background-200/50 text-foreground-500 border-background-300/30', icon: 'ri-information-line', label: action || 'Action' };
}

export function formatAuditDate(dateStr: string): string {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  return d.toLocaleString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}